import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import PencilIcon from '@offerzen/zenicon/PencilIcon'
import TrashIcon from '@offerzen/zenicon/TrashIcon'
import ItemIcon from '../ItemIcon'
import SmallText from '../../../typography/SmallText'
import Subheading from '../../../typography/Subheading'
import BadgeButton from '../../BadgeButton'
import styles, { itemSize } from './styles'

const StructuredItem = ({ theme, size, withBackground, icon, title, subtitle, className, children, onEdit, onDelete }) => (
  <li className={cx(styles.item, className, itemSize(size))}>
    <ItemIcon icon={icon} theme={theme} size={size} withBackground={withBackground} />
    <div className={styles.content}>
      <div className={styles.titleWrapper}>
        <Subheading className={styles.title}>{title}</Subheading>
        {Boolean(onEdit) && <BadgeButton className={styles.deleteButton} onClick={onEdit} icon={PencilIcon} ariaLabel={`Edit ${title}`} />}
        {Boolean(onDelete) && (
          <BadgeButton className={styles.deleteButton} onClick={onDelete} icon={TrashIcon} ariaLabel={`Delete ${title}`} />
        )}
      </div>
      <SmallText className={styles.subtitle}>{subtitle}</SmallText>
      {Boolean(children) && children}
    </div>
  </li>
)

StructuredItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

export default StructuredItem
